import { render, staticRenderFns } from "./MasterCombo.vue?vue&type=template&id=1db61958&scoped=true"
import script from "./MasterCombo.vue?vue&type=script&lang=js"
export * from "./MasterCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db61958",
  null
  
)

export default component.exports